<template>
  <div class="search-form-small">
    <h4>{{ $lang.translate(title) }}</h4>
    <div class="tracking-form-container mt-3">
      <form class="tracking-form" @submit.prevent="search">
        <input
          type="text"
          class="has-shadow"
          @input="checkForm"
          :class="{'is-error': isError}"
          :placeholder="$lang.translate('track.input.placeholder')"
          v-model="trackingNumber" />
        <button type="submit">
          <i class="icon-search"></i>
        </button>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Miniform',
  props: {
    title: {
      type: String,
      required: false,
      default: 'track.header.trackAgain'
    }
  },
  data() {
    return {
      trackingNumber: '',
      isError: false
    }
  },
  methods: {
    search() {
      if (this.isValid()) {
        this.isError = false
        this.$router.push({name: 'results', params: {trackingNumber: this.trackingNumber}})
      } else {
        this.isError = true
      }
    },

    checkForm () {
      if (this.isError) {
        this.isError = this.trackingNumber.length <= 2
      }
    },

    isValid () {
      return this.trackingNumber.length > 2
    }
  }
}
</script>

<style>
.search-form-small {
  text-align: center;
}

.search-form-small .tracking-form-container {
  max-width: 595px;
  margin: 0 auto;
}

.search-form-small input.is-error {
  border: 1px solid red;
}

</style>